import React, { useState } from 'react';
import { useTable } from 'react-table';
import {
  Button,
  IconButton,
  Tooltip,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import debounce from 'debounce';
import Loader from '../Loader';

const styles = (theme) => ({
  paper: {
    borderColor: '#ccc',
  },
  tableHead: {
    backgroundColor: '#ececec',
    color: theme.palette.colors.black70,
    fontWeight: 'bold',
  },
  tableHeadCell: {
    fontWeight: 'inherit',
    padding: '8px 10px',
    lineHeight: 1.3,
  },
  tableCell: {
    borderBottom: 'solid 1px #ddd',
    verticalAlign: 'middle',
    padding: '4px 10px',
    lineHeight: 1.3,
  },
  tableRow: {
    height: '45px',
  },
  itemActionButton: {
    marginRight: theme.spacing(1),
    color: theme.palette.colors.black70,
    backgroundColor: theme.palette.colors.yellow300,
    padding: theme.spacing(0.75),
  },
  actionButton: {
    backgroundColor: theme.palette.colors.yellow300,
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  searchField: {
    margin: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    width: '-webkit-fill-available',
  },
  searchBarContainer: {
    marginBottom: theme.spacing(2),
  },
});

const AmazTable = ({
  columns,
  data,
  dataRows,
  isLoading,
  pageSize,
  totalCount,
  onPageChange,
  onPageSizeChange,
  actionButtons,
  classes,
  onSearch,
  itemActionButtons,
  page,
  noPagination,
  noSearch,
  children,
  keyword,
  tableCellStyle = {},
}) => {
  const debouncedOnSearch = debounce(onSearch, 1500);
  const onChangeKeyword = (e) => {
    setTableKeyword(e.target.value);
    debouncedOnSearch(e.target.value);
  };
  const [tableKeyword, setTableKeyword] = useState(keyword);

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps, getTableBodyProps, headerGroups, rows, prepareRow,
  } = useTable({
    columns,
    data: dataRows || data || [],
  });


  // Render the UI for your table
  return (
    <>
      <Paper classes={{ root: classes.searchBarContainer }}>
        {!noSearch && (
          <TextField
            classes={{ root: classes.searchField }}
            margin="dense"
            label="Search"
            variant="outlined"
            value={tableKeyword || ''}
            onChange={onChangeKeyword}
          />
        )}
      </Paper>
      {children}
      {(actionButtons || []).map(({
        tooltip, onClick, content, ..._actionButtonRest
      }, i) => (
        <Button
          type="button"
          key={`tooltips-${i}-${tooltip}`}
          classes={{ root: classes.actionButton }}
          variant="contained"
          onClick={onClick}
          {..._actionButtonRest}
        >
          {content}
        </Button>
      ))}
      {isLoading ? <div className="flex-row flex-space-around" style={{ height: '100%' }}><Loader /></div>
        : (
          <TableContainer component={(props) => <Paper {...props} classes={{ root: classes.paper }} />}>
            <Table {...getTableProps()}>
              <TableHead classes={{ root: classes.tableHead }}>
                {headerGroups.map((headerGroup, i) => (
                  <TableRow key={`headerGroup-${i}`} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <TableCell key={column.Header} className={column.className} classes={{ head: classes.tableHeadCell }} {...column.getHeaderProps()}>
                        {column.render('Header')}
                      </TableCell>
                    ))}
                    {!_.isEmpty(itemActionButtons) && (
                    <TableCell classes={{ head: classes.tableHeadCell }}>Actions</TableCell>
                    )}
                  </TableRow>
                ))}
              </TableHead>
              <TableBody {...getTableBodyProps()}>
                {console.log(rows)}
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <TableRow key={`row-${i}`} classes={{ root: classes.tableRow }} {...row.getRowProps()}>
                      {row.cells.map((cell, ci) => (
                        <TableCell key={`cell-${i}-${ci}`} className={cell.column.className} {...cell.getCellProps()} classes={{ root: classes.tableCell }} style={tableCellStyle}>
                {cell.render('Cell')}
              </TableCell>
                      ))}
                      {!_.isEmpty(itemActionButtons) && (
                      <TableCell classes={{ root: classes.tableCell }}>
              <div className="nowrap">
                        {itemActionButtons
                          .map((_action) => (_.isFunction(_action) ? _action(row.original) : _action))
                          .filter((_action) => !_action.hidden)
                          .map((_action) => (
                            <div className="inline-block ml-1" key={_action.tooltip}>
                              <Tooltip title={_action.tooltip} aria-label={_action.tooltip}>
                                <IconButton
                                  classes={{ root: classes.itemActionButton }}
                                  onClick={(e) => {
                                    _action.onClick(e, row.original);
                                    e.stopPropagation();
                                  }}
                                >
                                  {_action.icon}
                                </IconButton>
                              </Tooltip>
                            </div>
                          ))}
                      </div>
            </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            {!noPagination && (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={totalCount || 0}
              rowsPerPage={pageSize || 25}
              page={page || 0}
              onChangeRowsPerPage={(e) => {
                onPageSizeChange(e.target.value);
              }}
              onChangePage={(e, page) => {
                onPageChange(page);
              }}
            />
            )}
          </TableContainer>
        )}
    </>
  );
};

export default withStyles(styles)(AmazTable);
